import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "step-title-wr"
}
const _hoisted_2 = {
  key: 0,
  class: "divider"
}
const _hoisted_3 = { class: "step-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!$setup.isDesktop)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($props.divider)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_3, _toDisplayString($props.title), 1)
      ]))
    : _createCommentVNode("", true)
}